var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideTitle || !_vm.hideNewTaskButton)?_c('header',{staticClass:"mb-4 d-flex justify-content-between align-items-center"},[(!_vm.hideTitle)?_c('span',{class:[
      'mb-0',
      {
        'h4': _vm.variant !== 'narrow',
        'h5': _vm.variant === 'narrow'
      }
    ]},[_c('i',{class:("fa fa-fw mx-1 " + _vm.icon + " " + _vm.iconColorClass)}),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.hideNewTaskButton)?_c('button',{staticClass:"btn btn-link text-body text-decoration-none",on:{"click":function($event){$event.preventDefault();return _vm.createNewTask()}}},[_c('i',{staticClass:"fa fa-plus mr-1"}),_vm._v("\n    New Task\n  ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }